import { Box, SelectChangeEvent, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BriaDropDown, { DropDownItem } from "../../../../components/common/BriaDropDown/BriaDropDown";
import BriaTooltip from "../../../../components/common/BriaTooltip/BriaTooltip";
import { IMAGE_REFERENCE_CONFIGS } from "../../../../constants/TextToImageConstants";
import { useAppStore } from "../../../../hooks/useStores";
import { FiboModel } from "../../../../models/text-to-image";
import styles from "./FiboModels.module.scss";

type FiboModelsProps = {
	activeTab: "generate" | "refine";
};

const FiboModels = ({ activeTab }: FiboModelsProps) => {
	const { t } = useTranslation("fibo", { keyPrefix: "lab.settings.fiboModels" });
	const { textToImageStore } = useAppStore();

	const isDisabled = activeTab === "refine";

	const customItem = (model: FiboModel) => {
		return (
			<Box className={styles.dropdownItem}>
				<Box className={styles.dropdownValueContainer}>
					<Typography className={styles.dropdownValue}>{t(model)}</Typography>
				</Box>
			</Box>
		);
	};

	const handleFiboModelChange = (e: SelectChangeEvent<FiboModel>) => {
		const newValue = e.target.value as FiboModel;
		textToImageStore.config = {
			...textToImageStore.config,
			model: newValue,
			model_id: newValue,
			model_version: newValue === "fibo_lite" ? "lite" : "",
			steps_num: IMAGE_REFERENCE_CONFIGS.steps[newValue].default,
		};
	};

	const fiboModelsItems: DropDownItem<FiboModel>[] = [
		{
			key: "fibo",
			value: "fibo",
			customItem: customItem("fibo"),
			customSelectedKey: customItem("fibo"),
		},
		{
			key: "fibo_lite",
			value: "fibo_lite",
			customItem: customItem("fibo_lite"),
			customSelectedKey: customItem("fibo_lite"),
		},
	];

	return (
		<BriaTooltip title={isDisabled ? t("disabledTooltip") : t("tooltip")} placement="right">
			<BriaDropDown<FiboModel>
				items={fiboModelsItems}
				value={textToImageStore.config.model as FiboModel}
				onChange={handleFiboModelChange}
				placeholder={t("placeholder")}
				width="100%"
				componentsProps={{
					root: { className: styles.dropdownButton },
				}}
				disabled={isDisabled}
			/>
		</BriaTooltip>
	);
};

export default observer(FiboModels);
